'use client';
import { ComposerContext } from '#pplx/frontend/composer-sdk/internal/input-state/context.js';
import { useCallback, useContext, useMemo } from 'react';
export function useComposerState() {
    const { state, dispatch } = useContext(ComposerContext);
    const setExpanded = useCallback((isExpanded) => dispatch({ type: 'SET_EXPANDED', payload: isExpanded }), [dispatch]);
    const setActive = useCallback((isActive) => dispatch({ type: 'SET_ACTIVE', payload: isActive }), [dispatch]);
    const setComposing = useCallback((isComposing) => dispatch({ type: 'SET_COMPOSING', payload: isComposing }), [dispatch]);
    const setStatus = useCallback((status) => dispatch({ type: 'SET_STATUS', payload: status }), [dispatch]);
    const setHasDraft = useCallback((hasDraft) => dispatch({ type: 'SET_HAS_DRAFT', payload: hasDraft }), [dispatch]);
    const setDisabled = useCallback((isDisabled) => dispatch({ type: 'SET_DISABLED', payload: isDisabled }), [dispatch]);
    return useMemo(() => ({
        ...state,
        setExpanded,
        setActive,
        setComposing,
        setStatus,
        setHasDraft,
        setDisabled,
    }), [state, setExpanded, setActive, setComposing, setStatus, setHasDraft, setDisabled]);
}
//# sourceMappingURL=useComposerState.js.map